import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
	process.env.REACT_APP_SUPABASE_URL,
	process.env.REACT_APP_SUPABASE_ANON_KEY
);

const incrementRequestCount = () => {
	let count = parseInt(localStorage.getItem("supabaseRequestCount") || "0", 10);
	localStorage.setItem("supabaseRequestCount", count + 1);
};

const wrapQuery = (method, ...args) => {
	const result = supabase[method](...args);

	return new Proxy(result, {
		get(target, prop) {
			if (typeof target[prop] === "function") {
				return (...subArgs) => {
					incrementRequestCount();
					console.log(`↳ [Supabase] ${method}`, ...args, `${prop}`, ...subArgs);

					const res = target[prop](...subArgs);
					// console.log(`↳ [Supabase] ${method}.${prop}() `, ...args); // { data, error }

					return res;
				};
			}
			return target[prop];
		},
	});
};

const loggedSupabase = {
	from: (...args) => wrapQuery("from", ...args),
	rpc: (...args) => wrapQuery("rpc", ...args),
	storage: supabase.storage,
	auth: supabase.auth,
};

export { loggedSupabase as supabase };
